import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { Observable } from 'rxjs';
import { StakeholderReponseDto } from '@cradua/data';

const route = 'stakeholderresponse/';
// /stakeholderresponse/counts/
const api = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class StakeholderResponseService {
  constructor(private http: HttpClient) {}
  filterPipelineRequest(criteria: any, stakeholderId) {
    return this.http.get<any[]>(
      api + route + 'filter/' + criteria + `?stakeholderId=${stakeholderId}`
    );
  }
  getGrouped(id: any): Observable<any> {
    console.log("Grouped route in service called")
    return this.http.get<any[]>(api + route + 'grouped/' + id);
  }
  getCount(stakeholderId): Observable<any> {
    return this.http.get<{ responded: number; unresponded: number }>(
      api + route + 'counts/' + stakeholderId
    );
  }

  getLastActivityResponse(activityId: any): Observable<StakeholderReponseDto> {
    return this.http.get<StakeholderReponseDto>(
      api + route + 'lastactivityresponse/' + activityId
    );
  }
  getActivityResponseHistory(
    activityId: any
  ): Observable<StakeholderReponseDto[]> {
    return this.http.get<StakeholderReponseDto[]>(
      api + route + 'responsehistory/' + activityId
    );
  }
}
